"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = exports.ListItemAction = exports.ListItemRemovable = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var noop = function noop() {};

var ListItemRemovable = function ListItemRemovable(_ref) {
  var item = _ref.item,
      _ref$remove = _ref.remove,
      remove = _ref$remove === void 0 ? noop : _ref$remove;
  return /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center px-4 py-4 sm:px-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 flex-1 flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 flex-1 px-4 md:grid md:grid-cols-1 md:gap-4"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-lg leading-5 font-dark text-gray-600 truncate"
  }, item)))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("svg", {
    className: "h-5 w-5 text-gray-400 hover:text-red-400",
    fill: "currentColor",
    viewBox: "0 0 20 20",
    onClick: remove
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    clipRule: "evenodd"
  }))))));
};

exports.ListItemRemovable = ListItemRemovable;

var ListItemAction = function ListItemAction(_ref2) {
  var item = _ref2.item,
      action = _ref2.action,
      _ref2$remove = _ref2.remove,
      remove = _ref2$remove === void 0 ? noop : _ref2$remove;
  return /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "block hover:bg-gray-50 focus:outline-none focus:bg-gray-50 transition duration-150 ease-in-out"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center px-4 py-4 sm:px-6"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 flex-1 flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "min-w-0 flex-1 px-4 md:grid md:grid-cols-1 md:gap-4"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-lg leading-5 font-dark text-gray-600 truncate"
  }, item)))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, action))));
};

exports.ListItemAction = ListItemAction;

var List = function List(_ref3) {
  var children = _ref3.children,
      className = _ref3.className;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-white overflow-hidden sm:rounded-md ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement("ul", null, children));
};

exports.List = List;